import axios from '../config/axiosConfig';
import { ADMIN_URL } from './constant/BaseApiUrl';

export default class UserService {
  getUserSecure(username, password) {
    return axios.post(
      `${ADMIN_URL}user-login`,
      {
        username,
        password
      },
      { metadata: { notRequiresToken: true } }
    );
  }

  getUsers() {
    return axios.get(`${ADMIN_URL}users`);
  }

  getUsersAssign() {
    return axios.get(`${ADMIN_URL}users-assign`);
  }
}
